import React from 'react';

import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';

import { InsightsRecommendationItem } from '../types';

interface Props {
  className?: string;
  recommendation: InsightsRecommendationItem;
  open: boolean;
  cardBgColor?: string;
  showFLowLine?: boolean;
}

function InsightRowReasons(props: Props) {
  const { className, recommendation, open, cardBgColor, showFLowLine = true } = props;

  return (
    <Box>
      {open ? (
        <Stack
          className={cn('relative isolate py-10 rounded-12', className)}
          direction="col"
          gapY={0}>
          {recommendation.card?.reasons.map((reason, index) => (
            <Box key={index} className="relative">
              {/* Curved corner using border radius - extends upward to connect */}
              {showFLowLine ? (
                <Box
                  className="absolute left-[0px] top-0 w-[14px] h-[25px]"
                  style={{
                    borderLeft: '1px solid var(--border-medium)',
                    borderBottom: '1px solid var(--border-medium)',
                    borderBottomLeftRadius: '16px',
                  }}
                />
              ) : null}
              {/* Horizontal line from curve to reason */}
              {showFLowLine ? (
                <Box className="absolute left-[14px] top-[24px] w-[14px] h-[1px] bg-border-medium" />
              ) : null}
              {/* Vertical line connecting to next reasons (if not last) */}
              {index < recommendation.card?.reasons.length - 1 && showFLowLine ? (
                <Box className="absolute left-[0px] top-[7px] bottom-0 w-[1px] bg-border-medium" />
              ) : null}

              <Box className={cn('mb-12', showFLowLine ? 'ml-[38px]' : 'ml-0')}>
                <Stack
                  alignItems="center"
                  className={'px-16 rounded-8 bg-bg-secondary'}
                  direction="row"
                  gap={12}>
                  <Typography
                    className={'flex-1 py-10'}
                    color="text-text-secondary"
                    variant="body-long-02">
                    {reason}
                  </Typography>
                </Stack>
              </Box>
            </Box>
          ))}
        </Stack>
      ) : null}
    </Box>
  );
}

export default React.memo(InsightRowReasons);
